import Application from "../../Application";
import GetAllCaseLawDocumentTypesInteractor from "../../caseLawDocuments/interactor/GetAllCaseLawDocumentTypesInteractor";
import OrganisationCaseLawDocumentTypesPresenter, {
  IOrganisationCaseLawDocumentTypesPresenter
} from "../../organisations/presenter/OrganisationCaseLawDocumentTypePresenter";
import GetAllOrganisationIndexCategoriesInteractor from "./GetAllOrganisationIndexCategoriesInteractor";

import GetCaseLawDocumentTypesForOrganisationInteractor from "./GetCaseLawDocumentTypesForOrganisationInteractor";
export default class ShowOrganisationDetailsCaseLawDocumentTypesInteractor {
  private application: Application;
  private output?: IOrganisationCaseLawDocumentTypesPresenter;
  private getCaseLawDocumentTypesForOrganisationInteractor: GetCaseLawDocumentTypesForOrganisationInteractor;
  private getAllOrganisationIndexCategoriesInteractor: GetAllOrganisationIndexCategoriesInteractor;
  private getAllCaseLawDocumentTypesInteractor: GetAllCaseLawDocumentTypesInteractor;

  constructor({
    application,
    getCaseLawDocumentTypesForOrganisation,
    getAllOrganisationIndexCategories,
    getAllCaseLawDocumentTypes
  }) {
    this.application = application;
    this.getCaseLawDocumentTypesForOrganisationInteractor =
      getCaseLawDocumentTypesForOrganisation;
    this.getAllOrganisationIndexCategoriesInteractor =
      getAllOrganisationIndexCategories;
    this.getAllCaseLawDocumentTypesInteractor = getAllCaseLawDocumentTypes;
  }
  private async getAllOrganisationCaseLawDocumentTypes(organisationId) {
    return this.getCaseLawDocumentTypesForOrganisationInteractor.execute(
      organisationId
    );
  }
  private async getAllOrganisationIndexCategories(organisationId) {
    return this.getAllOrganisationIndexCategoriesInteractor.execute(
      organisationId
    );
  }
  private async getAllCaseLawDocumentTypes() {
    return this.getAllCaseLawDocumentTypesInteractor.execute();
  }

  private async getReferenceLists(organisationId) {
    return Promise.all([
      this.getAllOrganisationCaseLawDocumentTypes(organisationId),
      this.getAllOrganisationIndexCategories(organisationId),
      this.getAllCaseLawDocumentTypes()
    ]);
  }
  execute(organisationId) {
    this.output = Object.assign(
      OrganisationCaseLawDocumentTypesPresenter({
        application: this.application,

        initialState: {
          organisationCaseLawDocumentTypes: [],
          organisationId,
          caseLawDocumentTypeIndexCategories: [],
          modalVisible: false,
          organisationIndexCategories: [],
          currentCaseLawDocumentTypeId: NaN,
          caseLawDocumentTypes: [],
          codeList: [],
          assignTypesToOrganisationModalVisible: false
        }
      })
    );
    this.getReferenceLists(organisationId).then(
      ([
        organisationCaseLawDocumentTypes,
        organisationIndexCategories,
        caseLawTypes
      ]) => {
        this.output?.loadReferenceValues(
          organisationId,
          organisationIndexCategories,
          caseLawTypes,
          organisationCaseLawDocumentTypes
        );
      }
    );

    return this.output;
  }
}
